import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, HostListener, inject, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, tap} from 'rxjs/operators';
import {FlashcardAttribute} from 'shared/flashcard';

@Component({
    selector: 'app-flashcard',
    templateUrl: './flashcard.component.html',
    styleUrls: ['./flashcard.component.scss'],
    standalone: false
})
export class FlashcardComponent implements OnInit, AfterViewInit {

    @HostBinding('class.is-playing') showPlayingCss = false;

    @Output() state = new EventEmitter<'is-playing' | 'is-selected'>();
    @Input() flashCard!: { id: string } & FlashcardAttribute;
    @Input() flashCardStopPlayingOrderSubject?: Subject<string[]>;
    @Input() resetFlashCardSubject?: Subject<boolean>;
    @Input() readBlocked = false;
    @Input() showTitleOnlyIfNoAudio = false;

    private player: HTMLAudioElement;
    private el = inject(ElementRef);
    private renderer = inject(Renderer2);
    public readTitle = false;

    @ViewChild('stream') set playerRef(ref: ElementRef<HTMLAudioElement>) {
        this.player = ref?.nativeElement;
    }

    ngOnInit(): void {
        if (this.resetFlashCardSubject) {
            this.resetFlashCardSubject.pipe(
                filter(() => this.showPlayingCss),
                tap(() => {
                    this.showPlayingCss = false;
                })
            ).subscribe();
        }
    }

    ngAfterViewInit(): void {
        //add tab index to permit focus
        this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0');

        if (this.flashCardStopPlayingOrderSubject && this.player) {
            this.flashCardStopPlayingOrderSubject.pipe(
                filter((idOfFlashCard) => idOfFlashCard.some((id) => id === this.flashCard.id)),
                tap(() => {
                    this.player.pause();
                    this.player.currentTime = 0;
                })
            ).subscribe();
        }
    }

    @HostListener('click')
    onClick($event): void {
        setTimeout(() => {
            this.readTitle = true;
        }, 100);
        this.triggerFlashcardAction();
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (event.repeat) {
            return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.triggerFlashcardAction();
        }
    }

    private triggerFlashcardAction(): void {
        if (this.player) { // If this flashcard contains an audio player
            this.player.pause();
            this.player.currentTime = 0;
            if (this.readBlocked) {
                return;
            } else {
                this.showPlayingCss = true;
                this.player.onended = () => {
                    this.showPlayingCss = false;
                    this.state.emit('is-selected');
                };
            }
            if (this.flashCard?.audio?.uri) {
                this.state.emit('is-playing');
                this.player.play();
            } else {
                // no sound on this flashcard we directly emit sound is finish
                this.state.emit('is-selected');
            }
        } else { // If this flashcard does not contain an audio player
            this.state.emit('is-selected');
        }
    }

    public reset(): void {
        this.showPlayingCss = false;
        this.player.pause();
    }

    get flashCardTitle() {
        const title = this.flashCard?.title;
        return typeof title === 'string' ? title : title?.value || '';
    }

}